module.exports = __webpack_public_path__ + "img/3d-image.8ef4d8e5.jpg";